import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwActionItemRequirement, DwMdFormActionHandler, DwMdFormActionState, DwWizardFinishService, DwWizardStateService, DwModalResult } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { map, mergeMap, tap } from "rxjs/operators";
import { SchoolRepositoryService } from "../services/school-repository.service";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";
import { AppMetaDataItemNames, CheckRideRequestEntity, FlightSchoolApplicantEntity } from "../../../meta-data/app-meta-data.service";
import { SchoolSwapStudentRequest } from "../models/school-swap-student-request.model";
import { SchoolSwapStudentModalComponent } from "../components/school-swap-student-modal/school-swap-student-modal.component";
import { SchoolSwapStudentResult } from "../models/school-swap-student-result.model";

@DwAction({
    keyName: 'school-swap-student-action',
    display: 'Change Applicant',
    actionType: DwActionType.formAction,
    parentItemName: AppMetaDataItemNames.CheckRideRequest,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Change Applicant',
        iconClass: 'fa fa-random',
        buttonClass: 'btn btn-danger',
        buttonTitle: 'Change Applicant'
    }
})
@Injectable()
export class SchoolSwapStudentActionService implements DwActionHandler {
    constructor(private dwModalService: DwModalService, private dwRoutingService: DwRoutingService) { }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        if (actionState.formApi.formGroup?.pristine) {
            const checkride = actionState.formApi.getFormData<CheckRideRequestEntity>();

            return this.startSwapAction(checkride);
        }

        return actionState.formApi.saveData(false)
            .pipe(mergeMap(saveResult => {
                if (!saveResult?.success) {
                    return of(saveResult);
                }

                const checkride = saveResult.saveResult as CheckRideRequestEntity;

                return this.startSwapAction(checkride);
            }));
    }

    private startSwapAction(checkride: CheckRideRequestEntity): Observable<DwActionResult> {
        const result = new DwActionResult();

        var request: SchoolSwapStudentRequest = {
            checkride: checkride
        };

        return this.showChangeApplicantModal(request)
            .pipe(map((modalResult) => {
                result.cancelled = modalResult.cancelled;
                result.success = !modalResult.cancelled;

                if (!modalResult.cancelled) {
                    if (modalResult.data?.newApplicantCheckride?.CheckRideRequestId) {
                        this.dwRoutingService.navigateToUrl(`/school-checkrides/edit/${modalResult.data.newApplicantCheckride.CheckRideRequestId}?changeApplicantComplete=true`, null);
                    }
                }

                return result;
            }));
    }

    showChangeApplicantModal(swapStudentRequest: SchoolSwapStudentRequest): Observable<DwModalResult<SchoolSwapStudentResult>> {
        let modalConfig = new DwModalConfig<SchoolSwapStudentRequest>();

        modalConfig.title = "Change Applicant";
        modalConfig.component = SchoolSwapStudentModalComponent;
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;

        modalConfig.buttons[0].buttonText = "Complete Change";
        modalConfig.allowFullScreen = true;
        modalConfig.data = swapStudentRequest;

        modalConfig.modalSize = DwModalSize.responsive;

        return this.dwModalService.showModal(modalConfig);
    }


}
